import type { MapState } from './types'
import { getMapSettingsObject, getMapLocationObject } from './utils'

const state = (): MapState => {
  const storedMapSettings = getMapSettingsObject()
  const storedMapLocation = getMapLocationObject()

  return {
    movingMode: false,
    deviceToMove: null,
    deviceViewMode: false,
    deviceToView: null,
    location: {
      center: storedMapLocation.center,
      zoom: storedMapLocation.zoom,
      lastZoom: storedMapLocation.lastZoom
    },
    shownSettings: {
      pinMeasurementType: storedMapSettings.pinMeasurementType,
      pinAqiType: storedMapSettings.pinAqiType,
      deviceModels: storedMapSettings.deviceModels,
      showMine: storedMapSettings.showMine,
      showPublic: storedMapSettings.showPublic,
      showShared: storedMapSettings.showShared,
      showIndoor: storedMapSettings.showIndoor,
      showOutdoor: storedMapSettings.showOutdoor
    }
  }
}

export default state
